import Phaser from 'phaser';
import Button from '~/components/buttons/Button';
import ScaleService from '~/services/ScaleService';
import { BF_Alert_Scene_Assets } from '~/utils/AssetLoader';
import { LoadImageAssets, UnloadImages } from '~/utils/AssetManager';

const modalHeight = 527;
const modalWidth = 494;
const modalRadius = 50;
const modalColor = 0x350926;
const modalAlpha = 1;
const modalBorderColor = 0x3d4361;
const modalBorderWidth = 1;

export default class HudBossFightAlertScene extends Phaser.Scene {
  private _scale;
  private _laterButton;
  private _letsgoButton;
  private _bossFightImage;
  private _bossFightTitle;
  private _bossFightText1;
  private _bossFightText2;

  constructor() {
    super({
      key: 'HudBossFightAlertScene',
    });
  }

  preload() {
    LoadImageAssets(this, BF_Alert_Scene_Assets);
  }

  create() {
    this._scale = ScaleService.getInstance().getScale(modalWidth, modalHeight);
    this.createComponent();
  }

  createComponent() {
    const background = this.add.rexRoundRectangle(
      0, // x
      0, // y
      this.sys.game.canvas.width * 2, // width
      this.sys.game.canvas.height * 2, // height
      0, // radius
      0x000000, // fillColor
      0.73, // alpha
    );

    this.add.existing(background);

    var sizer = this.rexUI.add.overlapSizer(this.sys.canvas.width / 2, this.sys.canvas.height / 2, {
      width: modalWidth * this._scale,
      height: modalHeight * this._scale,
      space: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        item: 0,
        line: 0,
      },
      align: 0,
      sizerEvents: true,
    });

    const notificationBg = this.add
      .rexRoundRectangle(
        0, // x
        0, // y
        this.applyScale(modalWidth), // width
        this.applyScale(modalHeight), // height
        this.applyScale(modalRadius), // radius
        modalColor, // fillColor
        modalAlpha, // alpha
      )
      .setStrokeStyle(modalBorderWidth, modalBorderColor, modalAlpha);

    sizer.add(notificationBg, {
      key: 'background',
      align: 'center',
      offsetX: 0,
      offsetY: 0,
      expand: false,
    });

    // Add Boss Image
    this._bossFightImage = this.add.image(0, 0, 'bossfight_notification_image').setScale(this._scale);

    sizer.add(this._bossFightImage, {
      key: 'bossfight_image',
      align: 'center-top',
      offsetX: 0,
      offsetY: 0,
      expand: false,
    });

    // Add Boss Title
    this._bossFightTitle = this.add.image(0, 0, 'bossfight_notification_title_text').setScale(this._scale);

    sizer.add(this._bossFightTitle, {
      key: 'bossfight_title_image',
      align: 'center-middle',
      offsetX: 0,
      offsetY: 0,
      expand: false,
    });

    // Text 1
    this._bossFightText1 = this.add.bitmapText(0, 0, 'cc_outline', 'The pack of Vermins\n have returned...', this.applyScale(22), 1);
    sizer.add(this._bossFightText1, {
      key: 'bossfight-text-1',
      align: 'center-top',
      offsetX: 0,
      offsetY: this.applyScale(325),
      expand: false,
    });

    // Text 2
    this._bossFightText2 = this.add
      .bitmapText(0, 0, 'cc_outline', 'Team up with your fellow\n Wolvez to take them down. You\n are our only hope...', this.applyScale(18), 1)
      .setTint(0xbfaac6);

    sizer.add(this._bossFightText2, {
      key: 'bossfight-text-2',
      align: 'center-top',
      offsetX: 0,
      offsetY: this.applyScale(390),
      expand: false,
    });

    // Add Later Button
    this._laterButton = new Button(this, 0, 0, 'bossfight_notification_later_button', true, 1.05).setScale(this._scale);

    this._laterButton.onClick().subscribe(pointer => {
      this.unloadAssets();
      this.scene.resume('HomebaseScene');
      this.scene.resume('HudScene');
      this.scene.stop();
    });

    this.add.existing(this._laterButton);

    sizer.add(this._laterButton, {
      key: 'later-button',
      align: 'left-top',
      offsetX: this.applyScale(89),
      offsetY: this.applyScale(497),
      expand: false,
    });

    // Add Later Button
    this._letsgoButton = new Button(this, 0, 0, 'bossfight_notification_letsgo_button', true, 1.05).setScale(this._scale);

    this._letsgoButton.onClick().subscribe(pointer => {
      this.unloadAssets();
      this.scene.get('HomebaseScene').scene.stop();
      this.scene.get('HudScene').scene.stop();
      this.scene.start('BossFightScene');
    });

    this.add.existing(this._letsgoButton);

    sizer.add(this._letsgoButton, {
      key: 'letsgo-button',
      align: 'left-top',
      offsetX: this.applyScale(239),
      offsetY: this.applyScale(497),
      expand: false,
    });

    sizer.layout();
  }

  applyScale(length) {
    return length * this._scale;
  }

  unloadAssets() {
    UnloadImages(this, Object.keys(BF_Alert_Scene_Assets));
  }
}
